import { useState, useEffect } from "react";
import { formatDurationCompact } from "../lib/utils/time";

export function Timer({
  startTime,
  duration,
  isDark = false,
  urgent = false,
}: {
  startTime: string;
  duration?: number;
  isDark?: boolean;
  urgent?: boolean;
}) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const updateElapsed = () => {
      const start = new Date(startTime).getTime();
      const newElapsed = Math.floor((Date.now() - start) / 1000);
      setElapsed(duration ? Math.max(0, duration - newElapsed) : newElapsed);
    };
    updateElapsed();
    const interval = setInterval(updateElapsed, 1000);
    return () => clearInterval(interval);
  }, [startTime, duration]);

  const tone = urgent
    ? isDark
      ? "text-red-400"
      : "text-red-600"
    : isDark
      ? "text-zinc-200"
      : "text-gray-700";

  return (
    <span
      className={`text-xl font-semibold tabular-nums tracking-widest ${tone} ${urgent ? "duel-countdown-timer" : ""}`}
    >
      {formatDurationCompact(elapsed)}
    </span>
  );
}
